import React from "react";
import { motion } from "framer-motion";
import { useContent } from "../context/ContentContext";

const ease = [0.16, 1, 0.3, 1];

export const Gallery = () => {
  const { content } = useContent();
  const GALLERY = content.gallery;
  return (
    <section id="galleria" data-testid="gallery-section" className="py-24 md:py-36 bg-paper">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="eyebrow mb-5">Realizzazioni</p>
            <h2 className="font-serif font-light text-4xl md:text-5xl leading-tight text-navy max-w-xl">
              Alcuni dei nostri lavori
            </h2>
          </div>
          <a
            href="#contatti"
            className="text-xs uppercase tracking-[0.2em] text-navy/70 link-underline self-start md:self-auto"
          >
            Inizia il tuo progetto
          </a>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease }}
              className={`group relative overflow-hidden bg-navy ${
                i === 0 || i === 3 ? "row-span-2 aspect-[3/4] lg:aspect-auto lg:h-full" : "aspect-square"
              }`}
            >
              <img
                src={g.img}
                alt={g.cap}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1.2s] ease-out"
              />
              <div className="absolute inset-0 bg-navy/0 group-hover:bg-navy/40 transition-colors duration-500" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="text-paper font-serif text-lg md:text-xl">{g.cap}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
